// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const E = (): JSX.Element => {
  window.location.href = '/api/sso/logout';
  return <></>;
};

export default E;
